/* eslint-disable no-unused-vars */


import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Wormhole from '@/components/Wormhole.vue'
// import NotFoundComponent from '@/components/NotFoundComponent.vue'
// import neatURL from 'neat-url'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        component: Home
    },
    {
        path: '/t/:magicCode?',
        name: 'tunel',
        component: Wormhole,

        // remove any marketing query params
        beforeEnter(to, from, next) {
            if (Object.keys(to.query).length) {
                next({
                    path: to.path,
                    query : null,
                    replace: true,
                })
            }
            next();
        }
    },
    {
        path: '/tech',
        name: 'tech',
        component: () => import(/* webpackChunkName: "tech" */ '../views/Tech.vue')
    },
    {
        path: '/o-nas',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '../views/Contact.vue')
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "404" */ '../views/NotFoundComponent.vue')
    }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
